// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"715":"c56261d9","9880":"1ed3a1d3"}[chunkId] + ".chunk.css";
};